import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'

export const AppEsignTermsOfUse: React.FC = () => {
    const data = [
        {
            'type': 1,
            'content': 'SHENMA Digital Signature Service Terms of Use',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'PLEASE READ AND UNDERSTAND THESE TERMS OF USE BEFORE YOU START THE DIGITAL ID VERIFICATION OR ELECTRONIC SIGNATURE SERVICE PROCESS AT SHENMA E-SIGN MOBILE. IF YOU DO NOT ACCEPT THESE TERMS OF USE, PLEASE DO NOT START THE DIGITAL ID VERIFICATION OR ELECTRONIC SIGNATURE PROCESS AT SHENMA E-SIGN MOBILE. ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '"Customer" means the person indicated, as the context requires and may refer without limitation to any person applying to Shenma Credit Sdn Bhd (“SHENMA Credit”) for services or products of the loan, any hirer under any hire purchase agreement, or any borrower under any loan agreement;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '"Electronic Know Your Customer " means the authentication or verification process of the Customer’s identity via the SHENMA E-Sign Mobile application and/or via any designated electronic signature service provider (“ESSP”)  (as updated from time to time) on the Customer’s mobile device;  ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '"Electronic Signature Service" means the services provided by SHENMA Credit to the Customer to allow the Customer to sign or execute the Loan Document in electronic form or by electronic means;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '"Electronic Signature Login Credentials" means password, Customer’s Identity Card number,  Customer’s mobile telephone number and/or any other password or information that SHENMA Credit may from time to time require for verifying the Customer’s identity for electronic signature of a Loan Document;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '"Loan Document" means any agreement, application or document as required by SHENMA Credit from time to time in respect of our accounts, products, services, loans and/or facilities in electronic form;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '“SHENMA E-Sign Mobile” means the mobile application owned by SHENMA Credit.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Words in the singular include the plural and words in the plural include the singular.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Clause headings in these Terms of Use are for ease of reference only.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'References to times of day shall unless otherwise stated be references to Malaysia time.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1. Terms of Use',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.1. If SHENMA Credit allows the Customer to use the Electronic Signature Service, the Customer shall comply with all applicable processes, procedures, and requirements established by SHENMA Credit and its ESSP, as may be updated from time to time.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.2. Prior to the issuance of the digital certificate for electronic signature, the Customer is required to complete the relevant Electronic Know Your Customer (eKYC) process according to the requirements of SHENMA Credit. The eKYC process may fail due to various reasons, including but not limited to NRIC tampering or service interruptions on SHENMA E-Sign Mobile. If the Customer completes the eKYC process and fails the verification of the ESSP responsible for issuing the digital certificate, the ESSP will notify the Customer via email, requesting the Customer to complete the necessary registration within three (3) days. In the event the Customer fails to complete the eKYC process with SHENMA Credit, SHENMA Credit will contact the Customer to provide further instructions on the next steps. ',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.3. The Customer agrees that Electronic Signature Login Credentials provides SHENMA Credit with reasonable and sufficient means of verifying the Customer’s identity in respect of the signing and submission of a Loan Document to SHENMA Credit through the Electronic Signature Service. SHENMA Credit is authorised to verify the Customer’s identity by the Electronic Signature Login Credentials. SHENMA Credit reserves the right to reject any electronically signed document if there are reasonable grounds to suspect fraud, unauthorized access, or non-compliance with applicable requirements.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.4. The Customer accepts that Electronic Signature Service provides a reliable and appropriate method for the Customer to electronically sign, submit and communicate a Loan Document to SHENMA Credit. All Loan Document received by SHENMA Credit with the Customer’s identity verified through the Electronic Signature Login Credentials shall be binding on the Customer.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.5. Upon successful verification of the Customer’s identity through the Electronic Signature Login Credentials, SHENMA Credit may treat the Loan Document as duly signed and submitted by the Customer, without any further obligation to verify its authenticity. ',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1.6. Once the Customer electronic signs a Loan Document,  the Customer is responsible to check and download a copy of the electronically signed Loan Document through SHENMA E-Sign Mobile. ',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '2. Representation and Warranties',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Customer represents and warrants to SHENMA Credit in relation to any electronic signature provided by the Customer that:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) each of the Customer’s authorised signatories has authorised and consented to SHENMA Credit collecting and linking their signatures with the Loan Document in electronic form;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) each of the Customer’s authorised signatories has agreed and acknowledged that their signatures on any document are reflected clearly and accurately and their signatures collected, received and/or stored in such electronic form shall be deemed to be equivalent to their respective signatures in hard copy, in ink and in original for all purposes provided such is collected or obtained in accordance with SHENMA Credit’s requirements and procedures;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) the electronic signature is the signature of the person to whom it correlates and the electronic signature was affixed by that person with the intention of signing or approving the electronic record;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) the electronic signature provided is valid, authentic and accurate; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) the electronic signature has been provided in a manner which complies and is in accordance with SHENMA Credit’s processes, procedures and requirements.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '3. Security measures',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '3.1. The Customer is responsible to obtain and maintain necessary devices and software by themselves to use the Electronic Signature Service and shall take all necessary security measures on its own to prevent unauthorized persons from accessing or using the Electronic Signature Service in respect of which SHENMA Credit bears no responsibility. The Customer should ensure that the devices are not tampered with (e.g., ROOT accessed, hacked, jailbroken, etc.).',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '3.2. The Customer is responsible for the security and confidentiality of their own devices and Electronic Signature Login Credentials and they shall ensure that the devices and Electronic Signature Login Credential are not acquired or used by any unauthorized person at any time, in respect of which the Customer is solely responsible for all the associated risks.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '3.3. If the Customer is aware of any loss, theft, unauthorized access or attack or threat by software, hacker or virus of any devices and Electronic Signature Login Credentials, or any other circumstance that may lead to unauthorized use of the Electronic Signature Service, it shall promptly notify SHENMA Credit.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '4. Liabilities and Responsibilities ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit does not assume any liabilities for:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) any loss, damages, compensation, costs or expenses in connection with or arising from the use of the Electronic Signature Service by the Customer;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) any indirect loss, damages, claims, costs or expenses arising from or in connection with the use of the Electronic Signature Service by the Customer, irrespective of whether SHENMA Credit is aware of the possibility of such loss or damages;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) any delay, loss, destruction occurred during the transmission of any electronic data, any act or omission of any third party or force majeure;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) suspension, interruption, failure or unavailability of the Electronic Signature Service, or failure of SHENMA Credit to perform its obligations under the Terms of Use as a result of technical failure, disruption of communication lines, computer networks, devices or interruption of services, force majeure or other reason beyond the control of SHENMA Credit;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) any implied warranty in relation to any services, systems, procedures in relation to the Electronic Signature Service including any warranties of merchantability, satisfactory quality, fitness for a particular purpose, and/or compliance with description.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '5. Indemnity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Customer shall indemnify SHENMA Credit and keep it indemnified at all times against all losses, damages, costs, charges, expenses (including without limitation legal costs), claims, proceedings and actions (including without limitation by third parties) which it may sustain or suffer in connection with:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) the falsity, inaccuracy or incompleteness of any information provided by the Customer using the Electronic Signature Service;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) any breach by the Customer of any representations, warranties, undertakings of these Terms of Use;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) any statement, act, omission, default, fault, negligence or fraudulent or dishonest act or omission of the Customer or its authorised signatories using the Electronic Signature Service;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) any claim brought by any third party in respect of SHENMA Credit relying on any information provided by the Customer using the Electronic Signature Service; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) SHENMA Credit’s contemplation of or execution, exercise or enforcement of any its rights, powers, remedies, authorities or discretions against the Customer.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '6. Third Party Provider',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '6.1. The relevant ESSP may be provided by a third party provider, and may be subject to such terms and conditions as may be prescribed or issued by the third party provider (“Third Party Terms”). The Customer hereby acknowledges and agrees that it shall fully comply with such Third Party Terms, and that it is the Customer’s responsibility to check and read the updated version of these Third Party Terms and that the Customer is deemed to have accepted such Third Party Terms.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '6.2. If the Third Party Terms requires the Customer to enter into an agreement directly with the third party provider, the Customer agrees to enter into such agreement, and in any event, to be legally bound by the Third Party Terms.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '6.3. The Customer shall indemnify and keep SHENMA Credit harmless against all losses incurred or suffered by  SHENMA Credit  howsoever arising out of or in connection with (i) the Customer’s access or use of the Electronic Signature Service and/or the ESSP (or specific parts, functionalities or features thereof) or its non-compliance with the Third Party Terms and (ii) SHENMA Credit providing the Customer’s information (or information provided by the Customer) to and between any ESSP as contemplated herein. For the avoidance of doubt, any designation by SHENMA Credit of a ESSP shall not be deemed or considered as an endorsement, representation or warranty of or by SHENMA Credit with respect to any ESSP and that any use or reliance on the ESSP by the Customer is solely at its own risk.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '6.4. SHENMA Credit may be required to provide information relating to the Customer in order to facilitate the signing and transmission of the Loan Document via the relevant ESSP. The Customer hereby expressly and irrevocably permits and authorises SHENMA Credit as well as any of its employees, agents, officials and officers to transfer, disclose, divulge or reveal at any time in such manner and under such circumstances as SHENMA Credit deems necessary or expedient in its sole and absolute discretion and without prior reference to the Customer, any information whatsoever relating to the Customer (or provided by the Customer) (including without limitation, documents, agreements and/or information, particulars and/or details relating to its accounts, transactions, instructions, communications and/or operations with SHENMA Credit) (collectively, “Customer Information”) to and between any ESSP, for the purposes of the Customer and/or SHENMA Credit using the relevant ESSP as envisaged herein, and/or for such other purposes as contemplated herein.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '6.5. There may be from time-to-time inadvertent disclosures by SHENMA Credit and/or any of its employees, agents, officials and officers of Customer Information, for the purpose of the Customer using any ESSP, and/or for such other purposes as contemplated herein, and hereby waives all the Customer’s rights and remedies against SHENMA Credit for such inadvertent disclosures.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '7. Suspension, Unavailability, and Termination of the Electronic Signature Service',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.1. SHENMA Credit may determine the content, scope and methods in connection with the Electronic Signature Service from time to time, and change, suspend, restrict, terminate or cancel the Electronic Signature Service at any time. The Customer agrees that SHENMA Credit is not subject  to any obligations or liabilities due to the suspension or termination of the service.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.2. In case of suspension or unavailability of the Electronic Signature Service, the Customer shall continue to be bound by these Terms of Use.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '8. Amendments',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit may amend the Terms of Use from time to time. Any such amendment will be deemed accepted and become effective 14 days after such posting by SHENMA Credit. Terms of Use',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '9. Severability and Waiver',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If any provision herein is or becomes illegal, invalid, prohibited or unenforceable under any applicable laws, the remaining provisions will remain in full force and effect and shall not be affected. No failure or delay by SHENMA Credit in exercising their rights or remedies will operate as a waiver of any rights or remedies under these Terms of Use.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '10. Consent to Process Personal Information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Customer hereby agrees and consents to the collection, processing and use of all personal data provided to SHENMA Credit, as well as personal data that arises as a result of the provision of the Electronic Signature Service. ',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '11. Queries',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If the Customer wishes to make any queries or reach out to SHENMA Credit in relation to Electronic Signature Service or SHENMA E-Sign Mobile, the Customer may contact Consumer Service Unit through email or call SHENMA Credit at the following email address and contact number:-',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Consumer Service Unit',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Contact Number: +604 523 0033',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '12. Governing Law ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These Terms of Use will be governed solely by the laws of Malaysia without regard to the conflict of law principles. The Customer hereby consents to the exclusive jurisdiction of the Malaysian courts in Kuala Lumpur, Malaysia in all disputes arising out of relating to the use of Electronic Signature Service.',
            'paddingLeft': '25px',
            'underline': false
        },
     
  
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const EnhancedBoldText = ({ text }) => {
        // 同时匹配中英文双引号
        const parts = text.split(/(["“].*?["”])/g)
      
        return (
          <div>
            {parts.map((part, index) => {
              if (/^["“].*?["”]$/.test(part)) {
                // const content = part.slice(1, -1)
                return <strong key={index}>{part}</strong>
              }
              return <span key={index}>{part}</span>
            })}
          </div>
        )
      }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>
                    <EnhancedBoldText text={content} />
                </Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
